import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { bindActionCreators } from 'redux';
import { searchProbeShape } from 'app/shapes/search';
import { SearchProbeList } from 'app/components/shared/Probes';
import SearchActions from 'app/actions/SearchActions';

export class SearchProbeListContainer extends React.PureComponent {
  componentDidMount() {
    const { query, searchType } = this.props;
    this.getSearchProbes(query, searchType);
  }

  componentDidUpdate(prevProps) {
    const { query, searchType } = this.props;
    const { query: prevQuery, searchType: prevSearchType } = prevProps;

    if (query !== prevQuery || searchType !== prevSearchType) {
      this.getSearchProbes(query, searchType);
    }
  }

  getSearchProbes(query, searchType) {
    if (query && searchType) {
      this.props.searchActions.getSearchProbes(query, searchType);
    }
  }

  render() {
    const { probes } = this.props;
    return (
      <div className="cp-search-probes">
        <SearchProbeList probes={probes} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  query: state.getIn(['search', 'catalogSearch', 'query']),
  searchType: state.getIn(['search', 'catalogSearch', 'searchType']),
  probes: state.getIn(['search', 'catalogSearch', 'probes'])
});

const mapDispatchToProps = dispatch => ({
  searchActions: bindActionCreators(SearchActions, dispatch)
});

SearchProbeListContainer.propTypes = {
  probes: ImmutablePropTypes.mapOf(searchProbeShape, PropTypes.string),
  query: PropTypes.string,
  searchType: PropTypes.string,
  searchActions: PropTypes.objectOf(PropTypes.func)
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchProbeListContainer);
